import CSS from "./static/css/ErrorIcon.module.css";
import error_icon from "./static/img/error_icon_40@3x.png";

const ErrorIcon = () => {
    return(
        <div className={CSS.l_ErrorIcon_main}>
            <img src={error_icon} alt="error_icon" className={CSS.l_ErrorIcon_img} />
        </div>
    )
}

export default ErrorIcon;